import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateTime } from 'luxon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AiIsLoadingComponent } from '../../../basic/ai/ai-is-loading/ai-is-loading.component';
import { TruncatePipe } from '../../../basic/pipes/truncate.pipe';
import { SessionMessage } from '../../../core/session-message/session-message';
import { Session } from '../../../core/session/session';
import { BoardIconComponent } from '../../../domain/board/board-icon/board-icon.component';
import { FeedbackImprovementsComponent } from '../../../domain/feedback/feedback-improvements/feedback-improvements.component';

@Component({
  selector: 'app-seller-time-range',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzPopoverModule,
    NzToolTipModule,
    NzTabsModule,
    NzSkeletonModule,
    NzCommentModule,
    NzFormModule,
    NzModalModule,

    AiIsLoadingComponent,
    BoardIconComponent,
    FeedbackImprovementsComponent,

    TruncatePipe,
  ],
  templateUrl: './seller-time-range.component.html',
  styleUrl: './seller-time-range.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SellerTimeRangeComponent {
  @Input({ required: true }) session!: Session;

  @Input({ required: true }) index!: number;

  @Input({ required: true }) range!: {
    startTime: DateTime<boolean>;
    endTime: DateTime<boolean>;
    message: string;
    sessionMessage: SessionMessage;
  };

  @Input({ required: true }) leftPx!: string;
  @Input({ required: true }) widthPx!: string;

  @Input({ required: true }) sessionMessageList: SessionMessage[] = [];

  isPopoverVisible = false;

  constructor() {}

  ngOnInit() {}

  handleCancel() {
    this.isPopoverVisible = false;
  }

  onRangeClick() {
    this.isPopoverVisible = true;
  }
}
